import React from 'react';

function Shadows(props) {
    return (
        <defs>
            <filter id="shadow" x="0" y="0">
                <feOffset result="offOut" in="SourceAlpha" dx="1" dy="1" />
                <feGaussianBlur result="blurOut" in="offOut" stdDeviation="5" />
                <feBlend in="SourceGraphic" in2="blurOut" mode="normal" />
            </filter>
            <filter id="thread-shadow" x="0" y="0">
                <feOffset result="offOut" in="SourceAlpha" dx="1" dy="4" />
                <feGaussianBlur result="blurOut" in="offOut" stdDeviation="2" />
                <feBlend in="SourceGraphic" in2="blurOut" mode="normal" />
            </filter>
        </defs>
    )
}

export default Shadows;


// WEBPACK FOOTER //
// ./src/components/Shadows.js